import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DataService } from '@app-core/services/data/data.service';
import {
  BAD_CAMERA_MOUNTING_TABLE,
  BAD_CAMERA_MOUNTING_TABLE_TYPES,
  CAMERA_EVENT_LABLES,
  FLEETHEALTH_FILTER_TYPES,
  HEALTH_CHECK_TABLE_PAGE_SIZE,
  HEALTH_EVENT_LABLES,
  HEALTH_EVENT_LIST_TABLE,
  NO_EVENTS_IMAGE,
} from '@app-assets/constants/assets.constants';
import { MatDialog } from '@angular/material/dialog';
import { finalize, takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { AssetsService } from '@app-assets/services/assets.service';
import { MatSort } from '@angular/material/sort';
import {
  BadMountingCameraTableTypeEnum,
  CameraEventsResponse,
  CategoryListResponse,
  DiagnosticsQueryParams,
  DiagnosticsSubTabEnum,
  GetMuteEventsResponse,
  HealthCheckGlossaryParam,
  HealthEventListResponse,
  HealthEventParams,
  KeyValuePair,
  MutedEvent,
  SearchTypeEnum,
  SelectedFilter,
  cameraEventTypeList,
  healthListRow,
} from '@app-assets/models/assets.model';
import { RequestDownloadReportBody } from '@app-core/models/core.model';
import { HttpErrorResponse } from '@angular/common/http';
import { SnackBarService } from '@app-core/services/snackbar/snack-bar.service';
import { TranslateService } from '@ngx-translate/core';
import { AsyncDownloadsService } from '@app-core/services/async-downloads/async-downloads.service';
import { AsyncReportType } from '@app-core/constants/constants';
import { MixPanelService } from '@app-core/services/mixpanel/mix-panel.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { MuteBadCameraMountingComponent } from '@app-assets/components/mute-bad-camera-mounting/mute-bad-camera-mounting.component';
import { SelectSearchComponent } from '@app-assets/components/select-search/select-search.component';

interface HealthCheckTableDownloadReportBody extends RequestDownloadReportBody {
  eventType?: string;
  sort?: string;
}

@Component({
  selector: 'app-health-check-table',
  templateUrl: './health-check-table.component.html',
  styleUrls: ['./health-check-table.component.scss'],
})
export class HealthCheckTableComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild(SelectSearchComponent, { static: false }) selectSearchFilter: SelectSearchComponent;
  @ViewChild('paginator') public paginator: MatPaginator;
  @ViewChild('sort', { static: true }) public sort: MatSort;

  @Input() public labelToDisplay: string = '';
  @Input() public subtabSelected: string = DiagnosticsSubTabEnum.CameraEvents;
  @Input() public currentLang: string;
  @Input() public evenTypeSelected: string = '';
  @Input() public emptyCameraEventsAggregate: boolean;
  @Input() private fleetIdSelected: string = '';

  @Output()
  private selectedTableType = new EventEmitter();

  public healthTableColums: string[] = BAD_CAMERA_MOUNTING_TABLE;
  public healthEventsListDataSource = new MatTableDataSource<cameraEventTypeList | MutedEvent | healthListRow>([]);
  public totalCount: number = 0;
  public loader: boolean = true;
  public currenteventData: string[] = [];
  public tablePageSize: number = HEALTH_CHECK_TABLE_PAGE_SIZE;
  public IsMediaFileVideo: boolean = false;
  public isSearchButtonDisabled: boolean = true;
  public assetFilterTypeList = FLEETHEALTH_FILTER_TYPES().sort((a, b) => (a.label > b.label ? 1 : -1));
  public selectedTable: string = BadMountingCameraTableTypeEnum.ActiveEvents;
  public badCameraTableTypes: KeyValuePair[] = BAD_CAMERA_MOUNTING_TABLE_TYPES;
  public isInputReadonly = false;
  public isSearch: boolean = true;
  public tableTypeEnum = BadMountingCameraTableTypeEnum;
  public showTable: boolean;
  public assetFilterForm: FormGroup;
  public csvDownloadLoader = false;
  public csvDownloadSuccess: boolean = false;
  public disableSearch: boolean = true;
  public cameraEventLabels = CAMERA_EVENT_LABLES;
  public glossaryLoader: boolean;
  public selectedHealthEventGuide: CategoryListResponse;
  public definationSummary: string;
  public solutionSummary: string;
  public diagnosticsSubTabEnum = DiagnosticsSubTabEnum;
  public noEventsImage: string = NO_EVENTS_IMAGE;

  private searchedAssetId: string = '';
  private searchedDeviceId: string = '';
  private offset: number = 0;
  private currentFleet: string = '';
  private muteDialogSubscription: Subscription;
  private isInitialLoad = true;
  private filterSearched: SelectedFilter;
  private searchTypeEnum = SearchTypeEnum;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    public dataService: DataService,
    public translate: TranslateService,
    private dialog: MatDialog,
    private assetsService: AssetsService,
    private snackBarService: SnackBarService,
    private asyncDownloadsService: AsyncDownloadsService,
    private route: ActivatedRoute,
    private router: Router,
    private mixpanelService: MixPanelService
  ) {}

  public ngOnInit(): void {
    this.route.queryParams.pipe(takeUntil(this.ngUnsubscribe)).subscribe((params: DiagnosticsQueryParams) => {
      if (history.state.source !== 'pn-url-click') {
        return;
      }

      const deviceId = params['deviceId'];
      if (deviceId) {
        this.filterSearched = {
          selectedFilter: this.searchTypeEnum.DeviceIdFilter,
          value: deviceId,
        };
        this.searchByDeviceId(deviceId);
      } else if (this.searchedDeviceId) {
        this.clearFilter();
      }
    });

    this.setTableColumns(this.subtabSelected);
    this.healthEventsListDataSource.paginator = this.paginator;
    this.healthEventsListDataSource.data = new Array(5).fill(undefined);
    this.getEventListBasedOnTab(this.evenTypeSelected);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (this.isInitialLoad) {
      this.isInitialLoad = false;
      return;
    }

    if (changes?.emptyCameraEventsAggregate) {
      this.selectedTable = this.tableTypeEnum.MutedEvents;
      this.getBadCameraEvents(true);
    }

    if (this.selectedHealthEventGuide && changes.currentLang && changes.currentLang.currentValue && this.evenTypeSelected) {
      this.currentLang = changes.currentLang.currentValue;
      this.getCategoryList(this.currentLang.toLowerCase());
    }

    if (changes && changes.evenTypeSelected) {
      if (this.paginator) {
        this.paginator.pageIndex = 0;
      }
      this.offset = 0;
      this.evenTypeSelected = changes.evenTypeSelected.currentValue;
      this.getEventListBasedOnTab(this.evenTypeSelected);
      if (this.evenTypeSelected) {
        this.getCategoryList(this.currentLang.toLowerCase());
      }
      if (!this.evenTypeSelected?.length) {
        this.solutionSummary = null;
      }
    }

    if (changes && changes.subtabSelected && changes.subtabSelected.currentValue) {
      this.setTableColumns(changes.subtabSelected.currentValue);
      this.loader = true;
      if (this.paginator) {
        this.paginator.pageIndex = 0;
      }
      this.offset = 0;
      if (!this.evenTypeSelected && this.subtabSelected === this.diagnosticsSubTabEnum.CameraEvents) {
        this.getEventListBasedOnTab(this.evenTypeSelected);
      }
      if (this.currenteventData.includes(this.evenTypeSelected)) {
        if (this.searchedDeviceId && this.searchedDeviceId.length) {
          this.clearFilter();
        } else {
          this.getEventListBasedOnTab(this.evenTypeSelected);
        }
        this.getCategoryList(this.currentLang.toLowerCase());
      }
    }

    if (this.fleetIdSelected && changes.fleetIdSelected && changes.fleetIdSelected.currentValue) {
      this.searchedAssetId = null;
      this.searchedDeviceId = null;
      this.filterSearched = null;
      this.paginator.firstPage();
      this.offset = 0;
      this.isSearch = true;
      this.isInputReadonly = false;
      this.getEventListBasedOnTab(this.evenTypeSelected);
    }

    this.csvDownloadSuccess = null;
  }

  public ngAfterViewInit(): void {
    this.healthEventsListDataSource.sort = this.sort;

    this.paginator.page.pipe(takeUntil(this.ngUnsubscribe)).subscribe((event: PageEvent) => {
      this.offset = event.pageIndex * this.tablePageSize;

      const { selectedFilter = this.searchTypeEnum.AssetIdFilter, value = null } = this.filterSearched || {};

      if (selectedFilter === this.searchTypeEnum.AssetIdFilter && value) {
        this.searchByAssetId(value);
      } else if (selectedFilter === this.searchTypeEnum.DeviceIdFilter && value) {
        this.searchByDeviceId(value);
      } else {
        this.getEventListBasedOnTab(this.evenTypeSelected);
      }
    });

    this.sort?.sortChange.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      this.paginator.pageIndex = 0;
      this.offset = 0;
      this.getEventListBasedOnTab(this.evenTypeSelected);
    });

    this.dataService._currentFleet.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      this.currentFleet = res;
      if (this.currentFleet && this.evenTypeSelected) {
        this.getCategoryList(this.currentLang.toLowerCase());
      }
    });
  }

  private setTableColumns(selectedTab?: string) {
    if (selectedTab === this.diagnosticsSubTabEnum.CameraEvents) {
      this.healthTableColums = BAD_CAMERA_MOUNTING_TABLE;
      this.currenteventData = Object.keys(CAMERA_EVENT_LABLES);
    } else if (selectedTab === this.diagnosticsSubTabEnum.HealthEvent) {
      this.healthTableColums = HEALTH_EVENT_LIST_TABLE;
      this.currenteventData = Object.keys(HEALTH_EVENT_LABLES);
    }
  }

  private searchByAssetId(assetId: string) {
    if (!assetId) {
      return;
    }
    this.loader = true;
    this.searchedAssetId = assetId;
    if (this.searchedDeviceId) {
      this.searchedDeviceId = null;
    }
    this.healthEventsListDataSource.data = new Array(1).fill(undefined);
    this.isSearch = false;
    this.getEventListBasedOnTab(this.evenTypeSelected);
  }

  private searchByDeviceId(deviceId: string) {
    if (!deviceId) {
      return;
    }
    this.loader = true;
    this.searchedDeviceId = deviceId;
    if (this.searchedAssetId) {
      this.searchedAssetId = null;
    }
    this.healthEventsListDataSource.data = new Array(1).fill(undefined);
    this.isSearch = false;
    this.getEventListBasedOnTab(this.evenTypeSelected);
    this.isInputReadonly = true;
  }

  private isVideo(mediaType: string) {
    if (mediaType !== 'IMAGE') {
      this.IsMediaFileVideo = true;
    } else {
      this.IsMediaFileVideo = false;
    }
  }

  private getFleetCameraEventsList(eventType?: string) {
    this.loader = true;
    const params: HealthEventParams = {
      limit: this.tablePageSize,
      offset: this.offset,
      startDate: this.assetsService.getStartDate(),
    };

    if (this.searchedAssetId && this.searchedAssetId.length) {
      params.assetId = this.searchedAssetId;
    }

    if (eventType && eventType.length) {
      params.eventType = eventType;
    }

    if (this.searchedDeviceId && this.searchedDeviceId.length) {
      params.deviceId = this.searchedDeviceId;
    }

    if (this.sort && this.sort.active && this.sort.direction) {
      params.sort = this.sort.direction;
    }

    this.assetsService
      .getCameraEventList(params)
      .pipe(
        takeUntil(this.ngUnsubscribe),
        finalize(() => {
          this.loader = false;
        })
      )
      .subscribe(
        (res: CameraEventsResponse) => {
          const { totalCount = 0, rows = [] } = res || {};
          this.healthEventsListDataSource.data = rows;
          this.totalCount = totalCount;

          if (this.healthEventsListDataSource.data.length > 0) {
            this.healthEventsListDataSource.data.forEach((event: cameraEventTypeList) => {
              if (event?.mediaFiles && event?.mediaFiles[0]?.mediaFile && event?.mediaFiles[0].mediaType) {
                this.isVideo(event?.mediaFiles[0].mediaType);
              }
            });
          }
        },
        () => {
          this.healthEventsListDataSource.data = [];
          this.totalCount = 0;
        }
      );
  }

  private getFleetHealthEventsList(eventType: string) {
    this.loader = true;
    const params: HealthEventParams = {
      eventType,
      limit: this.tablePageSize,
      offset: this.offset,
      startDate: this.assetsService.getStartDate(),
    };

    if (this.searchedAssetId) {
      params.assetId = this.searchedAssetId;
    }

    if (this.searchedDeviceId) {
      params.deviceId = this.searchedDeviceId;
    }

    if (this.sort && this.sort.active && this.sort.direction) {
      params.sort = this.sort.direction;
    }

    this.assetsService
      .getFleetHealthList(params)
      .pipe(
        takeUntil(this.ngUnsubscribe),
        finalize(() => {
          this.loader = false;
        })
      )
      .subscribe(
        (res: HealthEventListResponse) => {
          const { totalCount = 0, rows = [] } = res || {};
          this.healthEventsListDataSource.data = rows;
          this.totalCount = totalCount;
        },
        () => {
          this.healthEventsListDataSource.data = [];
          this.totalCount = 0;
        }
      );
  }

  private getEventListBasedOnTab(value: string) {
    if (this.subtabSelected === this.diagnosticsSubTabEnum.CameraEvents) {
      this.getBadCameraEvents();
    } else if (value !== null && this.subtabSelected === this.diagnosticsSubTabEnum.HealthEvent) {
      this.getFleetHealthEventsList(value);
    }
  }

  public muteEvent(row, clickType: string, event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }

    const dialogRef = this.dialog.open(MuteBadCameraMountingComponent, {
      position: { top: '24px' },
      disableClose: true,
      width: '800px',
      autoFocus: false,
      panelClass: ['mobile-modal', 'media-popup-mute-events'],
      data: {
        event: {
          ...row,
          eventTypeLabel: this.evenTypeSelected
            ? CAMERA_EVENT_LABLES[this.evenTypeSelected].label
            : CAMERA_EVENT_LABLES[row.eventType].label,
          eventVideoFilename: row?.mediaFiles?.[0].mediaFile || [],
        },
        clickType,
        selectedTableType: this.selectedTable,
      },
    });

    this.muteDialogSubscription = dialogRef.afterClosed().subscribe((success: boolean) => {
      if (success) {
        const increaseCount = this.selectedTable === this.tableTypeEnum.MutedEvents ? true : false;
        let unselectAll;
        if (this.healthEventsListDataSource.data.length === 1) {
          this.evenTypeSelected = '';
          unselectAll = true;
        }
        this.selectedTableType.emit({
          selectedTableType: this.selectedTable,
          refreshGraph: true,
          increaseCount,
          subEvent: row.eventType,
          unselectAll,
        });
        this.getBadCameraEvents();
      }
    });
  }

  public exportHealthCheck() {
    this.csvDownloadSuccess = null;
    this.csvDownloadLoader = true;

    const { selectedFilter = null, value = null } = this.filterSearched || {};

    const body: HealthCheckTableDownloadReportBody = {
      reportType: null,
      fleetId: this.fleetIdSelected,
      startDate: this.assetsService.getStartDate(),
    };

    if (this.evenTypeSelected) {
      body['eventType'] = this.evenTypeSelected;
    }

    if (selectedFilter === this.searchTypeEnum.AssetIdFilter && value) {
      body['assetId'] = value;
    } else if (selectedFilter === this.searchTypeEnum.DeviceIdFilter && value) {
      body['deviceId'] = value;
    }
    if (this.sort && this.sort.active && this.sort.direction) {
      body['sortBy'] = this.sort.active;
      body['sort'] = this.sort.direction;
    }
    if (this.subtabSelected) {
      if (this.subtabSelected === this.diagnosticsSubTabEnum.CameraEvents) {
        body.reportType =
          this.selectedTable === this.tableTypeEnum.ActiveEvents ? 'FLEET_CAMERA_EVENTS' : 'FLEET_SUPRESSED_DIAGNOSTICS_EVENTS';
      } else if (this.subtabSelected === this.diagnosticsSubTabEnum.HealthEvent) {
        body.reportType = 'FLEET_HEALTH_EVENTS';
      }
    }
    this.mixpanelService.track('Health Check Table Download Reports', {
      'Report Type': this.subtabSelected,
      'Fleet Id': this.fleetIdSelected,
      'Event Type': this.evenTypeSelected,
      'Start Date': this.assetsService.getStartDate(),
    });

    this.asyncDownloadsService
      .requestDownloadReport(body)
      .pipe(
        finalize(() => (this.csvDownloadLoader = false)),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(
        () => {
          this.csvDownloadSuccess = true;
        },
        (err: HttpErrorResponse) => {
          this.csvDownloadSuccess = false;
          if (err?.status === 409) {
            this.snackBarService.failure(this.translate.instant('tripListComponentTripDuplicate'));
          } else {
            this.snackBarService.failure(this.translate.instant('tripListComponentTripsDownloadFailure'));
          }
        }
      );
  }

  public schedule() {
    if (this.subtabSelected) {
      if (this.subtabSelected === this.diagnosticsSubTabEnum.CameraEvents) {
        this.mixpanelService.track('Schedule Clicked- From Camera Events Export options', {
          'Report Type': AsyncReportType.fleetCameraEvents.key,
        });
        this.asyncDownloadsService.navigateToCreateSchedule(AsyncReportType.fleetCameraEvents.key);
      } else if (this.subtabSelected === this.diagnosticsSubTabEnum.HealthEvent) {
        this.mixpanelService.track('Schedule Clicked- From Health Events Export options', {
          'Report Type': AsyncReportType.fleetHealthEvents.key,
        });
        this.asyncDownloadsService.navigateToCreateSchedule(AsyncReportType.fleetHealthEvents.key);
      }
    }
  }

  public navigateToDownloads() {
    let reportType = null;
    if (this.subtabSelected === this.diagnosticsSubTabEnum.CameraEvents) {
      reportType =
        this.selectedTable === this.tableTypeEnum.MutedEvents
          ? AsyncReportType.supressedDiagnosticsEventsReport.key
          : AsyncReportType.fleetCameraEvents.key;
    } else if (this.subtabSelected === this.diagnosticsSubTabEnum.HealthEvent) {
      reportType = AsyncReportType.fleetHealthEvents.key;
    }
    this.asyncDownloadsService.navigateToExportHistory(reportType);
  }

  public tableTypeChanged(event: MatButtonToggleChange) {
    this.loader = true;
    this.selectedTable = event.value;
    this.selectedTableType.emit({ selectedTableType: this.selectedTable, refreshGraph: false });
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      this.offset = 0;
    }
    this.getBadCameraEvents();
  }

  private getBadCameraEvents(changeSubtab?: boolean) {
    if (changeSubtab) {
      this.selectedTable = this.emptyCameraEventsAggregate ? this.tableTypeEnum.MutedEvents : this.tableTypeEnum.ActiveEvents;
    }
    if (this.selectedTable === this.tableTypeEnum.ActiveEvents) {
      this.getFleetCameraEventsList(this.evenTypeSelected);
    } else {
      this.getFleetMutedEventsList(this.evenTypeSelected);
    }
  }

  private getFleetMutedEventsList(eventType?: string) {
    this.loader = true;
    const params = {
      limit: this.tablePageSize,
      offset: this.offset,
      startDate: this.assetsService.getStartDate(),
    };

    if (this.searchedAssetId) {
      params['assetId'] = this.searchedAssetId;
    }

    if (eventType && eventType.length) {
      params['eventType'] = eventType;
    }

    if (this.searchedDeviceId) {
      params['deviceId'] = this.searchedDeviceId;
    }

    if (this.sort && this.sort.active && this.sort.direction) {
      params['sort'] = this.sort.direction;
    }

    if (this.currentFleet) {
      params['fleetId'] = this.currentFleet;
    }

    this.assetsService
      .getMutedEventsList(params)
      .pipe(
        takeUntil(this.ngUnsubscribe),
        finalize(() => {
          this.loader = false;
        })
      )
      .subscribe(
        (res: GetMuteEventsResponse) => {
          const { totalCount = 0, rows = [] } = res || {};
          this.healthEventsListDataSource.data = rows;
          this.totalCount = totalCount;

          if (this.healthEventsListDataSource.data.length > 0) {
            this.healthEventsListDataSource.data.forEach((event: MutedEvent) => {
              if (event?.mediaFiles && event?.mediaFiles[0]?.mediaFile && event?.mediaFiles[0].mediaType) {
                this.isVideo(event?.mediaFiles[0].mediaType);
              }
            });
          }
        },
        () => {
          this.healthEventsListDataSource.data = [];
          this.totalCount = 0;
        }
      );
  }

  private getCategoryList(currentLang: string) {
    this.glossaryLoader = true;
    const params: HealthCheckGlossaryParam = {
      healthEventId: this.evenTypeSelected,
    };

    if (currentLang) {
      params.language = currentLang;
    }
    this.assetsService
      .getGlossaryOfDevice(params)
      .pipe(
        takeUntil(this.ngUnsubscribe),
        finalize(() => (this.glossaryLoader = false))
      )
      .subscribe(
        (res: CategoryListResponse) => {
          this.selectedHealthEventGuide = res;
          const guides = res.healthEventTroubleshootingGuides;
          const { summary: summarySolution } = guides[0];
          const { summary: summaryDefinations } = guides[1];

          this.definationSummary = summaryDefinations[0].healthEventSummary[0];
          this.solutionSummary = summarySolution[0];
        },
        () => {
          this.glossaryLoader = false;
        }
      );
  }

  public clearFilter() {
    this.loader = true;
    this.filterSearched = null;
    this.searchedDeviceId = null;
    this.searchedAssetId = null;
    this.paginator.firstPage();
    this.offset = 0;
    this.isSearch = true;
    this.isInputReadonly = false;
    this.healthEventsListDataSource.data = new Array(5).fill(undefined);
    this.getEventListBasedOnTab(this.evenTypeSelected);

    //clear query params
    const queryParams = { ...this.route.snapshot.queryParams };
    if (queryParams.deviceId) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { deviceId: null },
        queryParamsHandling: 'merge',
        state: { source: 'clear-filter' },
      });
    }
  }

  public search(event) {
    this.paginator.firstPage();
    this.offset = 0;
    this.filterSearched = event;
    const { selectedFilter = this.searchTypeEnum.AssetIdFilter, value } = event;
    if (selectedFilter === this.searchTypeEnum.AssetIdFilter) {
      this.searchByAssetId(value);
    } else if (selectedFilter === this.searchTypeEnum.DeviceIdFilter) {
      this.searchByDeviceId(value);
    }
  }

  public clearSearchFilter() {
    this.selectSearchFilter.clearInput();
    this.isSearch = true;
  }

  public ngOnDestroy() {
    if (this.muteDialogSubscription) {
      this.muteDialogSubscription.unsubscribe();
    }
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
